// Riferimento ammissibilità RC Economia Solidale (Norme Tariffarie / Glossario / Art. 34).
// Contenuto normativo statico usato dalla pagina Ammissibilità e dal wizard preventivo.

export const AMMESSI = [
  { title: "Enti del Terzo Settore", desc: "Compresi gli Enti sportivi ed Enti non profit, anche non iscritti al RUNTS." },
  { title: "Cooperative o Consorzi di cooperative" },
  { title: "Imprese Impatto", desc: "Organizzazioni con obiettivi di impatto sociale e/o ambientale." },
  { title: "Enti religiosi", desc: "Inclusi gli enti ecclesiastici e le parrocchie." },
  { title: "Enti pubblici", desc: "Limitatamente alle sole attività di volontariato." },
];

export const ETS_TIPOLOGIE = [
  { title: "Associazione di promozione sociale", desc: "Associazioni senza fini di lucro (riconosciute, non riconosciute, movimenti, gruppi o coordinamenti, federazioni)." },
  { title: "Organizzazione / Associazione di volontariato", desc: "Associazioni composte da soli volontari con esclusive finalità solidaristiche." },
  { title: "Cooperativa sociale", desc: "Gestisce servizi sociosanitari/educativi o attività finalizzate all'inserimento lavorativo di persone svantaggiate." },
  { title: "Ente filantropico", desc: "Associazioni riconosciute o fondazioni che erogano denaro, beni o servizi a sostegno di svantaggiati o per interessi generali." },
  { title: "Ente religioso", desc: "Enti sottoposti a confessioni religiose che destinano le attività al culto o materie connesse." },
  { title: "Fondazione", desc: "Ente costituito da un complesso di beni destinato al perseguimento di uno scopo." },
  { title: "Impresa sociale", desc: "Enti privati (incluse società di persone, di capitale, cooperative e consorzi) che esercitano attività d'impresa di interesse generale senza scopo di lucro." },
  { title: "ONG – Organizzazione non governativa", desc: "Senza fini di lucro, gestita prevalentemente da volontari e indipendente dagli Stati." },
  { title: "Rete associativa", desc: "Composta da almeno 100 enti o 20 fondazioni con sedi in almeno 5 regioni." },
  { title: "Società di mutuo soccorso", desc: "Istituzioni a base associativa volontaria basate sull'aiuto reciproco." },
  { title: "Altro Ente del Terzo Settore", desc: "Enti privati costituiti per finalità civiche, solidaristiche e di utilità sociale." },
];

export const IMPRESE_IMPATTO = [
  { title: "Società benefit" },
  { title: "Imprese certificate B-CORP" },
  { title: "Finanza etica", desc: "Società del Gruppo Banca Etica, MAG (Mutua Auto Gestione) ed enti operanti nella finanza etica e/o nel microcredito-microfinanza." },
  { title: "Imprese agricole bio / biodinamiche" },
  { title: "Green Economy", desc: "Imprese operanti nella Green Economy (fino a 50 addetti)." },
  { title: "Economia Solidale", desc: "Imprese operanti nell'Economia Solidale (fino a 50 addetti)." },
  { title: "Socie di Banca Etica", desc: "Imprese socie di Banca Etica (fino a 50 addetti)." },
  { title: "Start up innovative a vocazione sociale (SIAVS)" },
  { title: "Imprese femminili" },
  { title: "Imprese Culturali e Creative" },
  { title: "Economia del Bene Comune", desc: "Imprese aderenti all'Economia del Bene Comune." },
];

export const ALTRI_ENTI = [
  { title: "Enti e Società sportive", desc: "Associazioni e società regolarmente costituite e operanti nell'ambito sportivo." },
  { title: "C.E.R.S. – Comunità Energetiche Rinnovabili Solidali", desc: "Associazioni le cui attività includono anche la proprietà di impianti fotovoltaici." },
  { title: "Associazioni e organizzazioni ecclesiali o laiche", desc: "In collaborazione con le parrocchie per la gestione di attività e servizi." },
  { title: "Strutture socio-assistenziali e di accoglienza", desc: "Case di riposo, RSA gestite da cooperative, comunità ad alta intensità, case-famiglia, dormitori e ricoveri per senza dimora, immigrati e rifugiati." },
];

export const ESCLUSI = [
  { title: "Ospedali, IRCCS, cliniche e case di cura" },
  { title: "Ambulatori, poliambulatori e laboratori di analisi" },
  { title: "Centri diagnostici e centri di riabilitazione" },
  { title: "Ordini e associazioni professionali in genere" },
  { title: "Case di riposo o RSA non gestite da cooperative" },
  { title: "Centri per ricoveri di lunga degenza" },
];

export const SECTIONS = [
  { key: "ammessi", label: "Soggetti ammessi", accent: "emerald", items: AMMESSI,
    note: "L'assicurazione è specificamente dedicata e può essere stipulata da:" },
  { key: "ets", label: "Tipologie di Enti del Terzo Settore", accent: "blue", items: ETS_TIPOLOGIE,
    note: "Soggetti classificati come ETS nel Glossario di polizza." },
  { key: "impatto", label: "Imprese Impatto", accent: "blue", items: IMPRESE_IMPATTO,
    note: "Organizzazioni con obiettivi di impatto sociale e/o ambientale." },
  { key: "altri", label: "Altri enti con coperture dedicate", accent: "blue", items: ALTRI_ENTI,
    note: "Enti e associazioni specifici menzionati per coperture dedicate." },
  { key: "esclusi", label: "Enti esclusi (Art. 34)", accent: "rose", items: ESCLUSI,
    note: "Soggetti che NON possono essere assicurati con questa polizza." },
];

// Rilevazione locale (live nel wizard) delle tipologie escluse Art.34.
const HARD_EXCL = [
  ["ospedale", "Ospedali"], ["ospedalier", "Ospedali"], ["irccs", "IRCCS"],
  ["clinica", "Cliniche"], ["casa di cura", "Case di cura"],
  ["poliambulatorio", "Poliambulatori"], ["ambulatorio", "Ambulatori"],
  ["laboratorio di analisi", "Laboratori di analisi"], ["laboratorio analisi", "Laboratori di analisi"],
  ["centro diagnostico", "Centri diagnostici"],
  ["centro di riabilitazione", "Centri di riabilitazione"], ["centro riabilitazione", "Centri di riabilitazione"],
  ["ordine professionale", "Ordini professionali"], ["albo professionale", "Ordini/albi professionali"],
  ["associazione professionale", "Associazioni professionali"],
  ["lunga degenza", "Centri per ricoveri di lunga degenza"], ["lungodegenza", "Centri per ricoveri di lunga degenza"],
];
const COND_EXCL = [
  ["residenza sanitaria", "Residenze sanitarie assistenziali (RSA)"],
  ["residenze sanitarie", "Residenze sanitarie assistenziali (RSA)"],
  ["rsa", "Residenze sanitarie assistenziali (RSA)"],
  ["casa di riposo", "Case di riposo"],
];

// Ritorna { label, conditional } se la tipologia è esclusa, altrimenti null.
export function detectExcluded(...parts) {
  const text = parts.filter(Boolean).join(" ").toLowerCase();
  if (!text.trim()) return null;
  const isCoop = text.includes("coop");
  const hard = HARD_EXCL.find(([kw]) => text.includes(kw));
  if (hard) return { label: hard[1], conditional: false };
  if (!isCoop) {
    const cond = COND_EXCL.find(([kw]) => text.includes(kw));
    if (cond) return { label: cond[1], conditional: true };
  }
  return null;
}

// Opzioni per il menu a tendina "Tipologia ente".
export const TIPOLOGIE_OPTIONS = [
  { group: "Enti del Terzo Settore", options: ETS_TIPOLOGIE.map((e) => ({ value: e.title, label: e.title })) },
  { group: "Imprese Impatto", options: IMPRESE_IMPATTO.map((e) => ({ value: e.title, label: e.title })) },
  { group: "Altri enti con coperture dedicate", options: ALTRI_ENTI.map((e) => ({ value: e.title, label: e.title })) },
  {
    group: "Enti esclusi (Art. 34)",
    options: [
      { value: "Ospedale, IRCCS, clinica, casa di cura", label: "Ospedali, IRCCS, cliniche e case di cura" },
      { value: "Ambulatorio, poliambulatorio, laboratorio di analisi", label: "Ambulatori, poliambulatori e laboratori di analisi" },
      { value: "Centro diagnostico, centro di riabilitazione", label: "Centri diagnostici e di riabilitazione" },
      { value: "Ordine professionale, associazione professionale", label: "Ordini e associazioni professionali" },
      { value: "RSA, casa di riposo", label: "RSA / Case di riposo (se non gestite da cooperative)" },
      { value: "Centro di lunga degenza", label: "Centri per ricoveri di lunga degenza" },
    ],
  },
];
